module.exports = __webpack_public_path__ + "static/media/blank-coverpage-headerfooter-default.76655bbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blank-coverpage-headerfooter-default.png
// module id = 2170
// module chunks = 17